<template>
  <div class="EventSummary">
    <science-sidebar></science-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Science/event_summary.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <div class="text-center" id="welcome">
    </div>
    <h2 id="candidate-heading">CHIME/FRB Saved Event Summary </h2>
    <b-container fluid>
      <b-row>
        <b-col md="4">
        </b-col>
        <b-col md="4" class="my-1">
          <a class="download-button"
            :href="downloadData"
            :download="catalogName">
            <b-button variant="dark">
              Download Catalog
            </b-button>
          </a>
        </b-col>
        <b-col md="4">
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-row>
        <b-col md="12" v-if="items.length != 0">
        <b-table show-empty
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
        >
          <template v-slot:cell(source)="row">{{row.value.first}} {{row.value.last}}</template>
          <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template>
          <template v-slot:cell(row-details)="row">
            <b-card>
              <ul>
                <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
              </ul>
            </b-card>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button size="sm"
                      @click.stop="generateAll(row.item);
                                  checkIfBaseband(row.item)"
                      class="mr-1">
              Select
            </b-button>
          </template>
        </b-table>
        </b-col>
        <b-col md="12" v-else>
          <p>Fetching data...</p>
        </b-col>
      </b-row>
      <details style="text-center">
        <summary id="dm-pipeline-summary" style="font-size:30px">Show intensity pipeline Results</summary>
        <dm-pipeline
          :rerunIntensityDM="rerunIntensityDM"
          :monitorJob="monitorJob"
          :saveParameters="saveParameters"
          :flagParamete="flagParameters"
          :badParameters="badParameters"
          :intensityDmPipelineItems="intensityDmPipelineItems"
        ></dm-pipeline>
      </details>
      <details>
        <summary id="fitburst-summary" style="font-size:30px">Show Fitburst Results</summary>
          <fitburst
            :rerunfitburst="rerunfitburst"
            :monitorJob="monitorJob"
            :saveParameters="saveParameters"
            :flagParamete="flagParameters"
            :badParameters="badParameters"
            :fitburstItems="fitburstItems"
          ></fitburst>
      </details>
      <details>
        <summary id="mcmc-summary" style="font-size:30px">Show MCMC Results</summary>
          <fitburstmcmc
            :saveParameters="saveParameters"
            :flagParamete="flagParameters"
            :badParameters="badParameters"
            :fitburstMCMCItems="fitburstMCMCItems"
          ></fitburstmcmc>
      </details>
      <details style="text-center">
        <summary id="calibration-summary" style="font-size:30px">Show Flux/Fluence Results</summary>
        <fluence
          :rerunintensitycalibration="rerunintensitycalibration"
          :monitorJob="monitorJob"
          :saveParameters="saveParameters"
          :flagParamete="flagParameters"
          :badParameters="badParameters"
          :fluenceItems="fluenceItems"
        ></fluence>
      </details>
      <details>
        <summary id="localization-summary"  style="font-size:30px">Show Localization Results</summary>
        <details>
          <summary id="header-localization-summary" style="font-size:20px"> Header Localization</summary>
          <header-localization
            :rerunHeaderLocalization="rerunHeaderLocalization"
            :monitorJob="monitorJob"
            :rerunheaderloc="rerunheaderloc"
            :saveParameters="saveParameters"
            :flagParamete="flagParameters"
            :badParameters="badParameters"
            :HeaderLocalizationItems="HeaderLocalizationItems"
          ></header-localization>
        </details>
        <details>
          <summary id="intensity-localization-summary" style="font-size:20px"> Intensity Localization</summary>
          <intensity-localization
            :saveParameters="saveParameters"
            :flagParamete="flagParameters"
            :badParameters="badParameters"
            :intensityLocalizationItems="intensityLocalizationItems"
          ></intensity-localization>
        </details>
      </details>
      <details style="text-center">
        <summary id="baseband-summary" style="font-size:30px">Show Baseband Results</summary>
        <baseband
          :saveParameters="saveParameters"
          :flagParamete="flagParameters"
          :badParameters="badParameters"
          :basebandItems="basebandItems"
        ></baseband>
      </details>
      <!-- Rerun Fitburst Modal -->
      <b-modal id="fitburst-modal"
                     title="Fitburst Parameters"
                     @ok="rerunFitburst"
      >
        <rerun-fitburst
          :fitburstForm="fitburstForm"
          :rerunFitburst="rerunFitburst"
        ></rerun-fitburst>
      </b-modal>

      <!-- Rerun DM Pipeline Modal -->
      <b-modal id="intensity-dm-pipeline-modal"
                     title="Intensity DM Pipeline Parameters"
                     @ok="rerunIntensityDMPipeline"
      >
        <rerun-dm-pipeline
          :intensityDMPipelineForm="intensityDMPipelineForm"
          :rerunIntensityDMPipeline="rerunIntensityDMPipeline"
        ></rerun-dm-pipeline>
      </b-modal>
      <b-modal id="intensity-calibration-modal"
                     title="Intensity Calibration Parameters"
                     @ok="rerunIntensityCalibration"
      >
        <rerun-fluence
          :intensityCalibrationForm="intensityCalibrationForm"
          :rerunIntensityCalibration="rerunIntensityCalibration"
        ></rerun-fluence>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
import { AnalysisMixin } from '../mixins/analysisMixin.js'
import scienceSidebar from './scienceSidebar'
import dmPipeline from '../dmPipeline'
import fitburst from '../fitburst'
import fitburstmcmc from '../fitburstMCMC'
import calibration from '../calibration'
import headerLoc from '../headerLoc'
import intensityLoc from '../intensityLoc'
import baseband from '../baseband'
import rerunFluence from '../rerunFluence'
import rerunIntensityDMComponent from '../rerunIntensityDMComponent'
import rerunFitburst from '../rerunFitburst'

// import VuePlotly from '@statnett/vue-plotly'
// import VueCsvDownloader from 'vue-csv-downloader'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
// baseUrl = 'http://localhost:8001/'
var previousItem = {}
var fields = [
  {key: 'source_name', label: 'Source Name', sortable: true, 'class': 'text-center'},
  {key: 'burst_name', label: 'Burst Name', sortable: true, 'class': 'text-center'},
  {key: 'event_id', label: 'Event No', sortable: true, 'class': 'text-center'},
  {key: 'morphology', label: 'Morphology', sortable: true, 'class': 'text-center'},
  {key: 'bonsai_snr', label: 'bonsai SNR', sortable: true, 'class': 'text-center'},
  {key: 'intensity_snr', label: 'Intensity SNR', sortable: true, 'class': 'text-center'},
  {key: 'fitburst_snr', label: 'Fitburst SNR', sortable: true, 'class': 'text-center'},
  {key: 'dm_snr', label: 'Intensity DM snr', sortable: true, 'class': 'text-center'},
  {key: 'dm_structure', label: 'Intensity DM structure', sortable: true, 'class': 'text-center'},
  {key: 'dm', label: 'Fitburst DM', sortable: true, 'class': 'text-center'},
  {key: 'ne2001_dm', label: 'NE2001', sortable: true, 'class': 'text-center'},
  {key: 'width', label: 'Fitburst Width (s)', sortable: true, 'class': 'text-center'},
  {key: 'scattering_timescale', label: 'Fitburst Scattering Time (s)', sortable: true, 'class': 'text-center'},
  {key: 'timestamp_UTC', label: 'Fitburst timestamp UTC@400MHz', sortable: true, 'class': 'text-center'},
  {key: 'flux', label: 'Flux (Jy)', sortable: true, 'class': 'text-center'},
  {key: 'fluence', label: 'Fluence (Jy ms)', sortable: true, 'class': 'text-center'},
  {key: 'ra', label: 'RA', sortable: true, 'class': 'text-center'},
  {key: 'dec', label: 'Dec', sortable: true, 'class': 'text-center'},
  {key: 'actions', label: 'Actions', 'class': 'text-center'}
]
export default {
  components: {
    'science-sidebar': scienceSidebar,
    'dm-pipeline': dmPipeline,
    'fitburst': fitburst,
    'fitburstmcmc': fitburstmcmc,
    'fluence': calibration,
    'header-localization': headerLoc,
    'intensity-localization': intensityLoc,
    'baseband': baseband,
    'rerun-fluence': rerunFluence,
    'rerun-dm-pipeline': rerunIntensityDMComponent,
    'rerun-fitburst': rerunFitburst
  },
  mixins: [AuthVerificationMixin, AnalysisMixin],
  data () {
    return {
      baseUrl: baseUrl,
      items: [],
      fields: [],
      repeaters: {},
      eventId: null,
      fitburstItems: [],
      rerunfitburst: false,
      rerunIntensityDM: false,
      rerunintensitycalibration: false,
      basebandItems: [],
      basebandData: false,
      intensityDmPipelineItems: [],
      intensityLocalizationItems: [],
      HeaderLocalizationItems: [],
      fluenceItems: [],
      showfields: [],
      smallTable: true,
      chosenRound: 3,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' },
      fieldtitle: 'User Ratings',
      previousItem: {},
      fitburstForm: {
        eventid: null,
        dm: null,
        // time: null,
        window: null,
        width: null,
        iterations: null,
        // specidx: null,
        // specrun: null,
        scatteringtimescale: null,
        components: null,
        cto: null,
        cfo: null,
        fixdm: false,
        badchannelmask: false,
        fixwindow: false
        // onlineWaterfaller: false,
        // mcmc: false
      },
      intensityDMPipelineForm: {
        id: null,
        input_dm: null,
        dm_range: null,
        downsample_factor: null
      },
      intensityCalibrationForm: {
        id: null,
        extend_window_left: null,
        extend_window_right: null
      }
    }
  },
  mounted () {
    this.reloadWindow()
    if (this.user) {
      document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
      var url = this.baseUrl + 'v1/sources/search/type/FRB?full_candidate=True'
      this.fetchSources(url)
      url = this.baseUrl + 'v1/sources/search/type/FRB_REPEATER?full_candidate=True'
      this.fetchRepeaters(url)
      this.getDelayedData()
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    nameState () {
      return this.knownsource.length > 7
    },
    catalogName () {
      var today = new Date()
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      return 'catalog-' + date + '.json'
    },
    downloadData () {
      var contentType = 'application/json'
      var dData = JSON.stringify(this.items, null, 2)
      var blob = new Blob([dData], {type: contentType})
      var url = window.URL.createObjectURL(blob)
      return url
    },
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    needcheckbox (value) {
      if (value === '') {
        return false
      }
      return true
    },
    fetchSources (url) {
      // var authHeaders = {'Authorization': 'Bearer ' + localStorage.accessToken}
      var authHeaders = {'Authorization': localStorage.accessToken}
      var waitTime = this.waitForIt(0)
      waitTime = this.waitBeforeExecution(waitTime)
      Promise.all([waitTime]).then(() => {
        this.sendRequestForSources(url, authHeaders)
      })
    },
    sendRequestForSources (url, authHeaders) {
      return this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseSources(response.body)
        }, response => {
        })
    },
    fetchRepeaters (url) {
      // var authHeaders = {'Authorization': 'Bearer ' + localStorage.accessToken}
      var authHeaders = {'Authorization': localStorage.accessToken}
      var waitTime = this.waitForIt(0)
      waitTime = this.waitBeforeExecution(waitTime)
      Promise.all([waitTime]).then(() => {
        this.sendRequestForSources(url, authHeaders)
      })
    },
    parseSources (sources) {
      for (var i = 0; i < sources.length; i++) {
        if (sources[i]['candidate_id'].length > 1) {
          for (var j = 0; j < sources[i]['candidate_id'].length; j++) {
            this.repeaters[sources[i]['candidate_id'][j]] = [true, sources[i]['source_name']]
          }
        } else {
          this.repeaters[sources[i]['candidate_id'][0]] = [false, sources[i]['source_name']]
        }
      }
    },
    getDelayedData () {
      // Create a new Promise and resolve after 2 seconds
      var myTimerPromise = this.waitForIt(3000) // wait for 2 seconds
      Promise.all([myTimerPromise]).then(() => {
        this.fetchCandidates()
      })
    },
    fetchCandidates () {
      // var authHeaders = {'Authorization': 'Bearer ' + localStorage.accessToken}
      var authHeaders = {'Authorization': localStorage.accessToken}
      var candsUrl = this.baseUrl + 'v1/candidates?full_candidate=True'
      var waitTime = this.waitForIt(0)
      waitTime = this.waitBeforeExecution(waitTime)
      Promise.all([waitTime]).then(() => {
        this.sendRequestForCandidates(candsUrl, authHeaders)
      })
    },
    sendRequestForCandidates (url, authHeaders) {
      return this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(eventresponse => {
          this.fields = fields
          this.parseResponse(eventresponse.body)
        }, eventeresponse => {
        })
    },
    fetchEvents () {
      var eventUrl = 'https://frb.chimenet.ca/frb-master/v1/events'
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(eventUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(eventresponse => {
          this.parseEvents(eventresponse.body)
        }, eventeresponse => {
        })
    },
    fetch_locked_pipeline_parameters (event) {
      var measuredParameters = event['measured_parameters']
      var lockedPipelines = event['locked']
      var pipelineResults = {}
      var realtimePipeline = measuredParameters[0]
      pipelineResults['realtime'] = [realtimePipeline]
      pipelineResults['intensity-fitburst'] = []
      pipelineResults['intensity-dm-pipeline'] = []
      pipelineResults['intensity-calibration'] = []
      pipelineResults['header-localization'] = []
      for (const pipeline in lockedPipelines) {
        for (var i = measuredParameters.length - 1; i > 0; i--) {
          var mp = measuredParameters[i]
          if (mp['pipeline']['name'] === pipeline && mp['measurement_id'] === lockedPipelines[pipeline] && mp['pipeline']['status'] === 'SUCCESS') {
            pipelineResults[pipeline].push(mp)
          }
        }
      }
      return pipelineResults
    },
    parseEvents (r) {
      var includedEvents = []
      for (var i = 0; i < r.length; i++) {
        var value = {}
        if (r[i]['id'] <= 43253151 && Object.keys(r[i]).includes('locked') && !includedEvents.includes(String(r[i]['id']))) {
          includedEvents.push(String(r[i]['id']))
          value['event_id'] = r[i]['id']
          value['_rowVariant'] = 'danger'
          var pipelineResults = this.fetch_locked_pipeline_parameters(r[i])
          value['bonsai_snr'] = pipelineResults['realtime'][0]['snr'].toFixed(1)
          // "galactic_dm": {"dm_model": "NE2001", "dm": 71.2463867297951},
          value['ne2001_dm'] = pipelineResults['realtime'][0]['galactic_dm']['dm'].toFixed(1)
          if (pipelineResults['intensity-dm-pipeline'].length > 0) {
            if (Object.keys(pipelineResults['intensity-dm-pipeline'][0]).includes('snr')) {
              value['intensity_snr'] = pipelineResults['intensity-dm-pipeline'][0]['snr'].toFixed(1)
            }
            if (Object.keys(pipelineResults['intensity-dm-pipeline'][0]).includes('dm_snr')) {
              value['dm_snr'] = pipelineResults['intensity-dm-pipeline'][0]['dm_snr']// .toFixed(1)
              value['dm_snr_error'] = pipelineResults['intensity-dm-pipeline'][0]['dm_snr_error']// .toFixed(2)
            }
            if (Object.keys(pipelineResults['intensity-dm-pipeline'][0]).includes('dm_structure')) {
              value['dm_structure'] = pipelineResults['intensity-dm-pipeline'][0]['dm_structure']// .toFixed(1)
              value['dm_structure_error'] = pipelineResults['intensity-dm-pipeline'][0]['dm_structure_error']// .toFixed(2)
            }
          }
          value['source_name'] = r[i]['source_name']
          value['burst_name'] = r[i]['burst_name']
          value['morphology'] = ((r[i]['isRepeater']) ? 'Repeater ' : '')
          value['morphology'] = value['morphology'] + ((r[i]['isSideLobe']) ? 'Far Sidelobe ' : '')
          if (pipelineResults['intensity-fitburst'].length >= 2) {
            var round2 = null
            var round3 = null
            for (var round = 0; round < pipelineResults['intensity-fitburst'].length; round++) {
              if (pipelineResults['intensity-fitburst'][round]['pipeline']['logs'].startsWith('Round 2')) {
                round2 = pipelineResults['intensity-fitburst'][round]
                var round2Idx = round
              }
              if (pipelineResults['intensity-fitburst'][round]['pipeline']['logs'].startsWith('Round 3')) {
                round3 = pipelineResults['intensity-fitburst'][round]
                var round3Idx = round
              }
            }
            var roundIdx = round2Idx
            if (round3 && Object.keys(round3).includes('snr') && Object.keys(round3).includes('ftest_statistic')) {
              // if ((round3['snr'] >= round2['snr']) && round3['ftest_statistic'] <= 0.01) {
              if ((round3['snr'] >= round2['snr'])) {
                var sum = 0
                for (var st = 0; st < round3['sub_burst_scattering_timescale'].length; st++) {
                  if (round3['sub_burst_scattering_timescale'][st] >= 0.0001 && round3['sub_burst_scattering_timescale'][st] > 3 * round3['sub_burst_scattering_timescale_error'][st]) {
                    sum = sum + 3
                  } else {
                    sum = sum + 2
                  }
                }
                if (sum / round3['sub_burst_scattering_timescale'].length === 3) {
                  roundIdx = round3Idx
                }
              }
            }
            var fp = pipelineResults['intensity-fitburst'][roundIdx]
            if (Object.keys(fp).includes('snr')) {
              value['fitburst_snr'] = fp['snr'].toFixed(1)
            }
            if (Object.keys(fp).includes('sub_burst_dm')) {
              value['dm'] = ''
              value['dm_error'] = ''
              value['morphology'] = value['morphology'] + ((fp['sub_burst_width'].length > 1) ? 'Complex ' : 'Simple ')
              for (var d = 0; d < fp['sub_burst_dm'].length; d++) {
                if (d > 0) {
                  value['dm'] = value['dm'] + ', ' + fp['sub_burst_dm'][d]// .toFixed(2)
                  value['dm_error'] = value['dm_error'] + ', ' + fp['sub_burst_dm_error'][d]// .toFixed(3)
                } else {
                  value['dm'] = fp['sub_burst_dm'][d]// .toFixed(2)
                  value['dm_error'] = fp['sub_burst_dm_error'][d]// .toFixed(3)
                }
              }
            }
            if (Object.keys(fp).includes('sub_burst_timestamp_UTC')) {
              value['timestamp_UTC'] = ''
              value['timestamp_UTC_error'] = ''
              for (var t = 0; t < fp['sub_burst_timestamp_UTC'].length; t++) {
                if (t > 0) {
                  value['timestamp_UTC'] = value['timestamp_UTC'] + ', ' + fp['sub_burst_timestamp_UTC'][t]
                  value['timestamp_UTC_error'] = value['timestamp_UTC_error'] + ', ' + fp['sub_burst_timestamp_error'][t]
                } else {
                  value['timestamp_UTC'] = fp['sub_burst_timestamp_UTC'][t]
                  value['timestamp_UTC_error'] = fp['sub_burst_timestamp_error'][t]
                }
              }
            }
            if (Object.keys(fp).includes('sub_burst_fluence')) {
              value['fitburst_fluence'] = ''
              value['fitburst_fluence_error'] = ''
              for (var w = 0; w < fp['sub_burst_fluence'].length; w++) {
                if (w > 0) {
                  value['fitburst_fluence'] = value['fitburst_fluence'] + ', ' + fp['sub_burst_fluence'][w]
                  value['fitburst_fluence_error'] = value['fitburst_fluence_error'] + ', ' + fp['sub_burst_fluence_error'][w]
                } else {
                  value['fitburst_fluence'] = fp['sub_burst_fluence'][w]
                  value['fitburst_fluence_error'] = fp['sub_burst_fluence_error'][w]
                }
              }
            }
            if (Object.keys(fp).includes('sub_burst_width')) {
              value['width'] = ''
              value['width_error'] = ''
              var scatts = []
              w = 0
              for (w = 0; w < fp['sub_burst_width'].length; w++) {
                scatts.push(Math.max(fp['sub_burst_width'][w] + 2 * fp['sub_burst_width_error'][w], 0.0001))
                if (fp['sub_burst_width'][w] < fp['sub_burst_width_error'][w]) {
                  fp['sub_burst_width'][w] = '<' + Math.max(fp['sub_burst_width'][w] + 2 * fp['sub_burst_width_error'][w], 0.0001)
                  fp['sub_burst_width_error'][w] = 0.0
                } else if (fp['sub_burst_width'][w] < 0.0001) {
                  fp['sub_burst_width'][w] = '<' + 0.0001
                  fp['sub_burst_width_error'][w] = 0.0
                }
                if (w > 0) {
                  value['width'] = value['width'] + ', ' + fp['sub_burst_width'][w]// .toFixed(7)
                  value['width_error'] = value['width_error'] + ', ' + fp['sub_burst_width_error'][w]// .toFixed(8)
                } else {
                  value['width'] = fp['sub_burst_width'][w]// .toFixed(7)
                  value['width_error'] = fp['sub_burst_width_error'][w]// .toFixed(8)
                }
              }
            }
            if (roundIdx === round2Idx) {
              value['scattering_timescale'] = '<' + Math.min(...scatts)
            } else {
              if (Object.keys(fp).includes('sub_burst_scattering_timescale')) {
                value['scattering_timescale'] = ''
                value['scattering_timescale_error'] = ''
                for (st = 0; st < fp['sub_burst_scattering_timescale'].length; st++) {
                  if (st > 0) {
                    value['scattering_timescale'] = value['scattering_timescale'] + ', ' + fp['sub_burst_scattering_timescale'][st]// .toFixed(7)
                    value['scattering_timescale_error'] = value['scattering_timescale_error'] + ', ' + fp['sub_burst_scattering_timescale_error'][st]// .toFixed(8)
                  } else {
                    value['scattering_timescale'] = fp['sub_burst_scattering_timescale'][st]// .toFixed(7)
                    value['scattering_timescale_error'] = fp['sub_burst_scattering_timescale_error'][st]// .toFixed(8)
                  }
                }
              }
            }
            if (Object.keys(fp).includes('sub_burst_spectral_index')) {
              value['spectral_index'] = ''
              value['spectral_index_error'] = ''
              for (var si = 0; si < fp['sub_burst_spectral_index'].length; si++) {
                if (si > 0) {
                  value['spectral_index'] = value['spectral_index'] + ', ' + fp['sub_burst_spectral_index'][si]
                  value['spectral_index_error'] = value['spectral_index_error'] + ', ' + fp['sub_burst_spectral_index_error'][si]
                } else {
                  value['spectral_index'] = fp['sub_burst_spectral_index'][si]
                  value['spectral_index_error'] = fp['sub_burst_spectral_index_error'][si]
                }
              }
            }
            if (Object.keys(fp).includes('sub_burst_spectral_running')) {
              value['spectral_running'] = ''
              value['spectral_running_error'] = ''
              for (var sr = 0; sr < fp['sub_burst_spectral_running'].length; sr++) {
                if (sr > 0) {
                  value['spectral_running'] = value['spectral_running'] + ', ' + fp['sub_burst_spectral_running'][sr]
                  value['spectral_running_error'] = value['spectral_running_error'] + ', ' + fp['sub_burst_spectral_running_error'][sr]
                } else {
                  value['spectral_running'] = fp['sub_burst_spectral_running'][sr]
                  value['spectral_running_error'] = fp['sub_burst_spectral_running_error'][sr]
                }
              }
            }
          } else {
            value['morphology'] = value['morphology'] + 'Simple'
          }
          if (pipelineResults['intensity-calibration'].length > 0) {
            if (Object.keys(pipelineResults['intensity-calibration'][0]).includes('sub_burst_flux')) {
              value['flux'] = pipelineResults['intensity-calibration'][0]['sub_burst_flux']
              value['flux_error'] = pipelineResults['intensity-calibration'][0]['sub_burst_flux_error']
            }
            if (Object.keys(pipelineResults['intensity-calibration'][0]).includes('sub_burst_fluence')) {
              value['fluence'] = pipelineResults['intensity-calibration'][0]['sub_burst_fluence']
              value['fluence_error'] = pipelineResults['intensity-calibration'][0]['sub_burst_fluence_error']
            }
          }
          if (pipelineResults['header-localization'].length > 0) {
            if (Object.keys(pipelineResults['header-localization'][0]).includes('ra')) {
              value['ra'] = pipelineResults['header-localization'][0]['ra'].toFixed(2)
              value['ra_error'] = pipelineResults['header-localization'][0]['ra_error'].toFixed(3)
            }
            if (Object.keys(pipelineResults['header-localization'][0]).includes('dec')) {
              value['dec'] = pipelineResults['header-localization'][0]['dec'].toFixed(2)
              value['dec_error'] = pipelineResults['header-localization'][0]['dec_error'].toFixed(3)
            }
          }
          this.items.push(value)
        }
      }
      document.getElementById('candidate-heading').innerHTML = 'CHIME/FRB Saved Event Summary: # Validated Candidates' + ': ' + this.items.length
    },
    parseResponse (events) {
      this.items = []
      var candEvents = []
      var badEvents = []
      for (var i = 0; i < events.length; i++) {
        for (var j = 0; j < events[i]['events'].length; j++) {
          if (events[i]['events'].length > 1) {
            events[i]['events'][j]['isRepeater'] = true
          }
          if (this.repeaters[events[i]['id']] === undefined) {
            badEvents.push(events[i]['events'][j]['id'])
            // events[i]['events'][j]['source_name'] = 'N/A'// events[i]['events'][j]
            events[i]['events'][j]['isRepeater'] = false
          } else {
            events[i]['events'][j]['isRepeater'] = this.repeaters[events[i]['id']][0]
            events[i]['events'][j]['source_name'] = this.repeaters[events[i]['id']][1]
            events[i]['events'][j]['burst_name'] = events[i]['id']
          }
          events[i]['events'][j]['isComplex'] = false
          events[i]['events'][j]['isSideLobe'] = false
          candEvents.push(events[i]['events'][j])
        }
      }
      this.parseEvents(candEvents)
    },
    fetchEvent (eventUrl, inputFunctions) {
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(eventUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          for (var i = 0; i < inputFunctions.length; i++) {
            inputFunctions[i](response.body)
          }
        })
    },
    generateAll (evItem) {
      evItem['_rowVariant'] = 'success'
      this.fitburstItems = []
      this.intensityDmPipelineItems = []
      this.intensityLocalizationItems = []
      this.HeaderLocalizationItems = []
      this.basebandItems = []
      this.fluenceItems = []
      this.eventId = evItem['event_id'].toString()
      this.fitburstForm['eventid'] = evItem['event_id'].toString()
      this.intensityDMPipelineForm['id'] = evItem['event_id'].toString()
      this.intensityCalibrationForm['id'] = evItem['event_id'].toString()
      var inputFunctions = [
        this.parseFluence,
        this.parseFitburst,
        this.parseIntensityDMPipeline,
        this.parseIntensityLocalization,
        this.parseHeaderLocalization,
        this.parseBaseband
      ]
      var eventUrl = this.baseUrl + 'v1/events/' + evItem['event_id']
      this.fetchEvent(eventUrl, inputFunctions)
      previousItem['_rowVariant'] = 'danger'
      previousItem = evItem
    },
    checkIfBaseband (evItem) {
      var bbUrl = this.baseUrl + '/v1/verification/get-verification/' + evItem['event_id']
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(bbUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.basebandData = false
          if (response.body['data_status']['baseband_data']) {
            this.basebandData = true
          }
        })
    },
    pad (number) {
      if (number < 10) {
        return '0' + number
      }
      return number
    },
    getProcessedAt (measurementID) {
      if ((typeof measurementID === 'string') && (measurementID.includes('-') || measurementID.includes(':'))) {
        return measurementID
      }
      var date = new Date(measurementID * 1000)
      var processedAt = date.getFullYear() + '-' + this.pad(date.getMonth() + 1) + '-' + this.pad(date.getDate()) + ' ' + this.pad(date.getHours()) + ':' + this.pad(date.getMinutes()) + ':' + this.pad(date.getSeconds())
      return processedAt
    },
    parseIntensityDMPipeline (eventData) {
      try {
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        var intensityDmPipelineItem = {}
        intensityDmPipelineItem['fitData'] = 0
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('intensity-dm-pipeline')) {
            lockedID = eventData['locked']['intensity-dm-pipeline']
          }
        }
        // Get latest intensity DM pipeline Results
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-dm-pipeline' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              intensityDmPipelineItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-dm-pipeline' &&
              eventData['measured_parameters'][i]['measurement_id'] > measurementID) {
              intensityDmPipelineItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }
        intensityDmPipelineItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-dm-pipeline/'
        intensityDmPipelineItem['all_beams'] = filePath + eventData['id'] + '_all_beams_waterfall_locked.png'
        intensityDmPipelineItem['snr_waterfall'] = filePath +
                                                  eventData['id'] +
                                                  '_snr_waterfall_locked.png'
        intensityDmPipelineItem['structure_waterfall'] = filePath +
                                                        eventData['id'] +
                                                        '_structure_waterfall_locked.png'
        intensityDmPipelineItem['boxcar_convolution'] = filePath +
                                                        eventData['id'] +
                                                        '_boxcar_convolution_locked.png'
        intensityDmPipelineItem['boxcar_convolution_profiles'] = filePath +
                                                                eventData['id'] +
                                                                '_boxcar_convolution_profiles_locked.png'
        intensityDmPipelineItem['dm_search'] = filePath +
                                              eventData['id'] +
                                              '_DM_Search_locked.png'
        intensityDmPipelineItem['5sig'] = filePath +
                                          eventData['id'] +
                                          '_Waterfall_5sig_locked.png'
        this.intensityDmPipelineItems.push(intensityDmPipelineItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseIntensityLocalization (eventData) {
      try {
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        var intensityLocalizationItem = {}
        intensityLocalizationItem['fitData'] = 0
        // Get latest intensity DM pipeline Results
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('intensity-localization')) {
            lockedID = eventData['locked']['intensity-localization']
          }
        }
        // Get latest intensity DM pipeline Results
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-localization' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              intensityLocalizationItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-localization' &&
              eventData['measured_parameters'][i]['measurement_id'] > measurementID) {
              intensityLocalizationItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }
        intensityLocalizationItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-localization/'
        intensityLocalizationItem['beamspec'] = filePath + eventData['id'] + '_Gaussian_beamspec.png'
        intensityLocalizationItem['corner'] = filePath + eventData['id'] + '_Gaussian_corner.png'
        this.intensityLocalizationItems.push(intensityLocalizationItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseHeaderLocalization (eventData) {
      try {
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        var HeaderLocalizationItem = {}
        HeaderLocalizationItem['fitData'] = 0
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('header-localization')) {
            lockedID = eventData['locked']['header-localization']
          }
        }
        // Get latest header localization Results
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'header-localization' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              HeaderLocalizationItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'header-localization' &&
              eventData['measured_parameters'][i]['measurement_id'] > measurementID) {
              HeaderLocalizationItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }
        HeaderLocalizationItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/header-localization/'
        HeaderLocalizationItem['header-localization'] = filePath + eventData['id'] + '_header-localization_locked.png'
        this.HeaderLocalizationItems.push(HeaderLocalizationItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseFluence (eventData) {
      try {
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        var fluenceItem = {}
        fluenceItem['fitData'] = 0
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('intensity-calibration')) {
            lockedID = eventData['locked']['intensity-calibration']
          }
        }
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-calibration' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              fluenceItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-calibration' &&
              eventData['measured_parameters'][i]['measurement_id'] > measurementID) {
              fluenceItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }
        fluenceItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var mainBeam = ('0000' + fluenceItem['fitData']['beam_number']).substr(-4, 4)
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                        burstDate.split(' ')[0].split('-')[0] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[1] +
                        '/' +
                        burstDate.split(' ')[0].split('-')[2] +
                        '/astro_' +
                        eventData['id'] +
                        '/intensity-calibration/'
        fluenceItem['fluence_diagnostic'] = filePath + eventData['id'] + '_fluence_diagnostic_plot_locked.png'
        fluenceItem['calibration_diagnostic'] = filePath + eventData['id'] + '_' + mainBeam + '_calibration_diagnostic_plot_locked.png'
        // fluenceItem[''] = filePath + eventData['id'] + '_PowerLaw_visual.png'
        this.fluenceItems.push(fluenceItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseBaseband (eventData) {
      try {
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        var basebandItem = {}
        basebandItem['fitData'] = 0
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('baseband')) {
            lockedID = eventData['locked']['baseband']
          }
        }
        // Get latest Baseband Results
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'baseband' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              basebandItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'baseband' &&
              eventData['measured_parameters'][i]['measurement_id'] > measurementID) {
              basebandItem['fitData'] = eventData['measured_parameters'][i]
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }
        basebandItem['processedAt'] = this.getProcessedAt(measurementID)
        // Pad beam number with '0' to four digits
        var burstDate = eventData['measured_parameters'][0]['datetime']
        basebandItem['data'] = '/baseband-archiver/' +
                                burstDate.split(' ')[0].split('-')[0] +
                                '/' +
                                burstDate.split(' ')[0].split('-')[1] +
                                '/' +
                                burstDate.split(' ')[0].split('-')[2] +
                                '/astro_' +
                                eventData['id'] +
                                '/baseband/processed/baseband_automatic_pipeline_locked.png'
        this.basebandItems.push(basebandItem)
      } catch (e) {
        console.error(e)
      }
    },
    parseFitburst (eventData) {
      try {
        var firstRound = {}
        var secondRound = {}
        var thirdRound = {}
        var measurementID = eventData['measured_parameters'][0]['measurement_id']
        // Get latest fitburst measurement ID
        var lockedID = false
        if (Object.keys(eventData).includes('locked')) {
          if (Object.keys(eventData['locked']).includes('intensity-fitburst')) {
            lockedID = eventData['locked']['intensity-fitburst']
          }
        }
        if (lockedID !== false) {
          for (var i = 1; i < eventData['measured_parameters'].length; i++) {
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-fitburst' &&
              eventData['measured_parameters'][i]['measurement_id'] === lockedID) {
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        } else {
          for (i = 1; i < eventData['measured_parameters'].length; i++) {
            var measurementIDToCompare = new Date(measurementID)
            var eventMeasurementID = new Date(eventData['measured_parameters'][i]['measurement_id'])
            if (eventData['measured_parameters'][i]['pipeline']['name'] === 'intensity-fitburst' &&
              eventMeasurementID >= measurementIDToCompare) {
              measurementID = eventData['measured_parameters'][i]['measurement_id']
            }
          }
        }

        firstRound['processedAt'] = this.getProcessedAt(measurementID)
        secondRound['processedAt'] = this.getProcessedAt(measurementID)
        thirdRound['processedAt'] = this.getProcessedAt(measurementID)
        // Get fit data for all rounds with right measurement ID
        var snrs = {'round2': 0, 'round3': 0}
        for (i = 0; i < eventData['measured_parameters'].length; i++) {
          if (eventData['measured_parameters'][i]['measurement_id'] === measurementID) {
            if (eventData['measured_parameters'][i]['pipeline']['logs'].split(' ')[1] === '1') {
              var model = 'Gaussian'
              if ('sub_burst_spectral_running' in eventData['measured_parameters'][i] ||
                  'sub_burst_spectral_index' in eventData['measured_parameters'][i]) {
                model = 'Spectral'
              }
              firstRound['fitData'] = eventData['measured_parameters'][i]
              firstRound['fitData']['pulse_model'] = model
            } else if (eventData['measured_parameters'][i]['pipeline']['logs'].split(' ')[1] === '2') {
              secondRound['fitData'] = eventData['measured_parameters'][i]
              secondRound['fitData']['pulse_model'] = model
              if (Object.keys(secondRound['fitData']).includes('snr')) {
                snrs['round2'] = secondRound['fitData']['snr']
              }
            } else {
              thirdRound['fitData'] = eventData['measured_parameters'][i]
              thirdRound['fitData']['pulse_model'] = model
              if (Object.keys(thirdRound['fitData']).includes('snr')) {
                snrs['round3'] = thirdRound['fitData']['snr']
              }
            }
          }
        }
        var showText = ''
        if (snrs['round2'] === 0 && snrs['round3'] === 0) {
          showText = 'Both rounds have failed. Make sure that the DM pipeline output is fine. If it is, re-run the pipeline with better input parameters. If not, first rerun the DM pipeline.'
        }
        if (snrs['round2'] > snrs['round3']) {
          showText = 'Round 2 is a better fit according to fitburst. Make sure that round 2 is as good as or better than round 1. If round 2 is truly statistically better than round 3, you should not see any evidence for scattering. It is ok if round 3 has failed, as long as you do not see a hint of scattering in the waterfall plots. If you can see scattering, it needs to be rerun with better parameters and round 3 should be the preferred model.'
        } else {
          showText = 'Round 3 is a better fit according to fitburst. Make sure that it looks equivalent or better than round 2. Also make sure that the residuals in round 3 look acceptable. Otherwise, it needs to be rerun with better input parameters.'
        }
        firstRound['showText'] = showText
        secondRound['showText'] = showText
        thirdRound['showText'] = showText
        // Pad beam number with '0' to four digits
        var mainBeam = ('0000' + firstRound['fitData']['beam_number']).substr(-4, 4)
        var burstDate = eventData['measured_parameters'][0]['datetime']
        var filePath = '/data/chime/intensity/processed/' +
                         burstDate.split(' ')[0].split('-')[0] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[1] +
                         '/' +
                         burstDate.split(' ')[0].split('-')[2] +
                         '/astro_' +
                         eventData['id'] +
                         '/' +
                         mainBeam +
                         '/intensity-fitburst/' +
                         eventData['id'] +
                         '_' +
                         mainBeam +
                         '_'
        // Generate all file names for fitburst generated plots
        firstRound['plot'] = filePath + 'round_one_fitburst_triptych_locked.png'
        firstRound['correlations'] = filePath + 'round_one__fitburst_correlations_locked.png'
        secondRound['plot'] = filePath + 'round_two_fitburst_triptych_locked.png'
        secondRound['correlations'] = filePath + 'round_two__fitburst_correlations_locked.png'
        thirdRound['plot'] = filePath + 'round_three_fitburst_triptych_locked.png'
        thirdRound['correlations'] = filePath + 'round_three__fitburst_correlations_locked.png'
        firstRound['pubplot'] = filePath + 'round_one_pubplot_locked.png'
        secondRound['pubplot'] = filePath + 'round_two_pubplot_locked.png'
        thirdRound['pubplot'] = filePath + 'round_three_pubplot_locked.png'
        secondRound['nofit'] = filePath + 'round_two_pubplot_nofit.png'
        thirdRound['nofit'] = filePath + 'round_three_pubplot_nofit.png'
        // this.fitburstItems.push(firstRound)
        this.fitburstItems.push(secondRound)
        this.fitburstItems.push(thirdRound)
      } catch (e) {
        console.error(e)
      }
    },
    rerunIntensityCalibration () {
      var command = ['python']
      var intensityCalibrationParameters = ['submit-calibration-jobs.py']
      // Generate list of parameters to run fitburst
      for (var property in this.intensityCalibrationForm) {
        if (typeof this.intensityCalibrationForm[property] === 'string') {
          if (this.intensityCalibrationForm[property] === '') {
            continue
          }
          intensityCalibrationParameters.push(this.intensityCalibrationForm[property])
        }
      }
      var ts = Math.round((new Date()).getTime() / 1000)
      var jobName = 'intensity-calibration-frb-web-' + this.intensityCalibrationForm['id'] + '-' + String(ts)
      var payload = {
        'image_name': 'chimefrb/frb-calibration:latest-airflow',
        'command': command,
        'arguments': intensityCalibrationParameters,
        'environment': {
          'FRB_MASTER_ACCESS_TOKEN': localStorage.accessToken,
          'FRB_MASTER_REFRESH_TOKEN': localStorage.refreshToken
        },
        'job_name': jobName,
        'mount_archiver': true,
        'swarm_network': true
      }
      var jobUrl = this.baseUrl + 'v1/swarm/spawn-job'
      this.rerunintensitycalibration = false
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(jobUrl, payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          if (response.status === 200) {
            this.rerunintensitycalibration = true
          }
        })
    },
    saveParameters (pipeline) {
      this.refreshToken()
      var lockUrl = this.baseUrl + 'v1/events/lock-measured-parameters/' + this.eventId + '/' + pipeline
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.put(lockUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          if (response.status === 200) {
            alert('You have successfully saved the results for ' + pipeline + ' for event: ' + this.fitburstForm.eventid)
          } else {
            alert('Could not save results due to error: Status Code:' + response.status + ' Response Text:' + response.text)
          }
        })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Science/event_summary.vue